/**
 * Note: This file exists just to provide a single entry point for the history hooks and allow a phased migration out of
 * the old hook. If you are reading this after january 2026 you can feel confident deleting the old hook.
 */

import { useHistoryControl as useNewHistoryControl, useSyncShellHistory as useNewSyncShellHistory } from './new-hook';
import { useHistoryControl as useOldHistoryControl, useSyncShellHistory as useOldSyncShellHistory } from './old-hook';

const hasNewShell = window?.shell?.featureAvailability?.has?.('navigation-history');

export const useHistoryControl = hasNewShell ? useNewHistoryControl : useOldHistoryControl;
export const useSyncShellHistory = hasNewShell ? useNewSyncShellHistory : useOldSyncShellHistory;
